import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IDispatcherTabPaneProps } from './types';
import { Badge, Flex } from 'antd';

const OVERFLOW_COUNT = 1000;

const HORIZONTAL_ELLIPSIS_UNICODE = '\u2026';

const DispatcherTabPane: FC<IDispatcherTabPaneProps> = memo(({ labelKey, badgeCount, loading }) => {
	const { t: tDispatcher } = useTranslation('dispatcher');
	return (
		<Flex
			gap='small'
			align='center'
			style={{ textTransform: 'uppercase' }}
		>
			{tDispatcher(`tabs.${labelKey}`)}
			<Badge
				showZero
				overflowCount={OVERFLOW_COUNT}
				count={loading && !badgeCount ? HORIZONTAL_ELLIPSIS_UNICODE : badgeCount}
			/>
		</Flex>
	);
});
export default DispatcherTabPane;
